/**
 * @flow
 * @relayHash d0508b64d39342fd389d12433e079274
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DeleteCountryMutationVariables = {|
  id: string
|};
export type DeleteCountryMutationResponse = {|
  +deleteCountry: {|
    +id: string
  |}
|};
export type DeleteCountryMutation = {|
  variables: DeleteCountryMutationVariables,
  response: DeleteCountryMutationResponse,
|};
*/


/*
mutation DeleteCountryMutation(
  $id: String!
) {
  deleteCountry(id: $id) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "deleteCountry",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "CountryModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "DeleteCountryMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "DeleteCountryMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "DeleteCountryMutation",
    "id": null,
    "text": "mutation DeleteCountryMutation(\n  $id: String!\n) {\n  deleteCountry(id: $id) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37c09524a8d2ea18df06884c6493928f';
module.exports = node;
